const SplitTestConstants = {
  ZRM_AI_LISTING_CREATION: 'zrm_ai_listing_creation',
} as const;

export default SplitTestConstants;
